import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import classNames from 'classnames'

const styles = {
  root: {
    maxWidth: 800,
  }
}

const Container = ({ classes, className, ...rest }) => (
  <div
    {...rest}
    className={classNames(className, classes.root)}
  />
)

Container.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.any,
}

export default withStyles(styles)(Container)
